<div class="modal-border">
  <ion-header>
    <ion-toolbar style="padding-left: 10px">
      <ion-row>
        <ion-col>
          <ion-title style="color: white">Help</ion-title>
        </ion-col>
        <ion-buttons>
          <ion-button (click)="dismissModal()" size="large" slot="end">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-row>
    </ion-toolbar>
  </ion-header>

  <ion-row>
    <div id="topButton" *ngIf="currentSectionIndex > 0">
      <ion-button size="small" (click)="scrollToPrevious()">
        <ion-icon
          name="return-up-back-outline"
          style="padding-right: 3px"
        ></ion-icon>
        {{ sections[currentSectionIndex - 1] }}
      </ion-button>
    </div>

    <div id="topButton" *ngIf="currentSectionIndex < sections.length - 1">
      <ion-button size="small" (click)="scrollToNextSection()"
        >{{ sections[currentSectionIndex + 1] }}
        <ion-icon
          name="return-down-forward-outline"
          style="padding-left: 3px"
        ></ion-icon>
      </ion-button>
    </div>

    <div>
      <ion-button id="popover-button" size="small" fill="clear">
        <ion-icon name="reorder-three-outline" size="large"></ion-icon>
      </ion-button>
      <ion-popover trigger="popover-button" [dismissOnSelect]="true">
        <ng-template>
          <ion-content>
            <ion-list>
              <ion-item
                [button]="true"
                (click)="scrollToSection('Introduction')"
                >Introduction</ion-item
              >
              <!-- <ion-item [button]="true" (click)="scrollToSection('Home')"
                >Home</ion-item
              > -->
              <ion-item [button]="true" (click)="scrollToSection('Training')"
                >Training</ion-item
              >
              <ion-item [button]="true" (click)="scrollToSection('Users')"
                >Users</ion-item
              >
              <ion-item [button]="true" (click)="scrollToSection('Lessons')"
                >Lessons</ion-item
              >
              <ion-item [button]="true" (click)="scrollToSection('Content')"
                >Manage content</ion-item
              >
              <!-- <ion-item [button]="true" (click)="scrollToSection('Contractors')"
                >Contractors</ion-item
              > -->
              <ion-item [button]="true" (click)="scrollToSection('Visitors')"
                >Visitors</ion-item
              >
              <ion-item [button]="true" (click)="scrollToSection('Settings')"
                >Site configuration</ion-item
              >
              <ion-item [button]="true" (click)="scrollToSection('Reports')"
                >Reports</ion-item
              >
              <ion-item [button]="true" (click)="scrollToSection('Resources')"
                >Resources</ion-item
              >
            </ion-list>
          </ion-content>
        </ng-template>
      </ion-popover>
    </div>
  </ion-row>

  <ion-content
    color="light"
    (ionScroll)="onScroll($event)"
    scrollEvents="true"
    class="ion-padding"
  >
    <div id="Introduction">
      <ion-title>Introduction</ion-title>
      <p>
        The STS XRS system was designed to assist Training Departments with the
        building and deployment of interactive and e-learning content for users.
        The XRS system is web-based, making it easier to deploy to users beyond
        the normal computer-based training classroom facilities. Users are able
        to complete training anytime, anywhere. This document serves as a
        training manual for the XRS system. It explains, in detail, how to
        perform the following activities on the system and serves as a reference
        guide for users.
      </p>
    </div>

    <div id="Training">
      <ion-title>Training</ion-title>
      <p>
        Use the Training centre is a section to access all lessons that are
        assigned to your profile sorted into 2 categories:
      </p>
      <ul>
        <li>Lessons required:</li>
        <p>
          these are lessons that have been assigned to your profile and must be
          completed, and 
        </p>

        <li>Lessons done:</li>
        <p>These are lessons that you have accessed and completed.</p>
      </ul>
    </div>

    <div id="Users">
      <ion-title>Users</ion-title>
      <p>
        This section lets facilitators manage users of the XRS platform
        including managing Clicker groups for PointSolutions™ Clicker devices
      </p>
      <ul>
        <li>Manage users</li>
        <p>
          Add, edit individual users and their details. For a video tutorial,
          click
          <a style="cursor: pointer" (click)="tutorialVid('Add users')"
            >here.</a
          >
          <br />
          For a video tutorial about assigning a user to lessons, click
          <a
            style="cursor: pointer"
            (click)="tutorialVid('Assigning a user to lessons')"
            >here.</a
          >
        </p>
        <li>Import list of users</li>
        <p>
          Batch import many users using and Excel list with user details
          exported from ERP systems. For a video tutorial, click
          <a
            style="cursor: pointer"
            (click)="tutorialVid('Import list of users')"
            >here.</a
          >
        </p>
        <li>Clicker groups</li>
        <p>
          Create and maintain clicker user groups of multiple users for
          PointSolutions™ clicker-based assessments. For a video tutorial, click
          <a
            style="cursor: pointer"
            (click)="tutorialVid('Assess a class using clickers')"
            >here.</a
          >
        </p>
        <li>Open sessions</li>
        <p>
          Manage open sessions that could be prevent students’ access to
          completing or restarting lessons. For a video tutorial, click
          <a style="cursor: pointer" (click)="tutorialVid('Manage sessions')"
            >here.</a
          >
        </p>
        <li>Assign sites</li>
        <p>
          Assign users to particular sites according to sites defined in the
          “Data lists” section under “Site configuration” menu.
        </p>
      </ul>
    </div>

    <div id="Lessons">
      <ion-title>Lessons</ion-title>
      <ul>
        <li>Manage lessons</li>
        <p>
          Create new lessons and edit new lessons and copy and de-activate old
          lessons. Note: A lesson cannot be edited if the lesson has been
          accessed through the Training centre because it will affect the
          integrity of results data reflected in reports. For a video tutorial
          about building lessons, click
          <a style="cursor: pointer" (click)="tutorialVid('Build lessons')"
            >here.</a
          >
          <br />
          For a video tutorial about assigning a lesson to users, click
          <a
            style="cursor: pointer"
            (click)="tutorialVid('Assigning a lesson to users')"
            >here.</a
          >
          <br />
          For a video tutorial about importing a list of questions and answers,
          click
          <a
            style="cursor: pointer"
            (click)="tutorialVid('Import questions and answers')"
            >here.</a
          >
        </p>
        <li>Manage courses</li>
        <p>Create a course that consists of multiple lessons.</p>
        <li>Manage procedures</li>
        <p>
          Create “Procedure” that seeks to have users acknowledge essential
          site-related procedures.
        </p>
        <li>Assign multiple Lessons</li>
        <p>
          Assign multiple lessons to multiple users.For a video tutorial, click
          <a
            style="cursor: pointer"
            (click)="tutorialVid('Assign multiple lessons')"
            >here.</a
          >
        </p>
      </ul>
    </div>

    <div id="Content">
      <ion-title>Manage content</ion-title>
      <p>
        Upload, tag, and search for content that can be used to build
        lessons.For a video tutorial, click
        <a style="cursor: pointer" (click)="tutorialVid('Manage content')"
          >here.</a
        >
      </p>
    </div>

    <!-- <div id="Contractors">
      <ion-title>Contractors</ion-title>
      <p>
        Define and manage Business partners, add contractor employees, configure
        contractor parameters and define Scopes of Work.
      </p>
    </div> -->

    <div id="Visitors">
      <ion-title>Visitors</ion-title>
      <p>
        Invite visitors via email to complete their induction course remotely
        before getting onto site.
      </p>
    </div>

    <div id="Settings">
      <ion-title>Site configuration</ion-title>
      <h5>Data lists</h5>
      <p>
        Configure lists of items that are populated when adding users, such as
        titles, departments, and job designations.
      </p>
    </div>

    <div id="Reports">
      <ion-title>Reports</ion-title>
      <p>
        Filter and generate reports for users that have worked through lessons
        on the XRS platform. Access metrics for lessons, and the site to review
        the training centre's performance.For a video tutorial, click
        <a style="cursor: pointer" (click)="tutorialVid('Extract reports')"
          >here.</a
        >
      </p>
    </div>

    <div id="Resources">
      <ion-title>Resources</ion-title>
      <p>
        Access the resources centre for video tutorials regarding critical XRS
        functions
        <a style="cursor: pointer" (click)="navigateToURL('/resources')"
          >here.</a
        >
      </p>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />

    <ion-col id="bottomButton" class="modal-ion-col-bottom-buttons">
      <ion-button
        (click)="scrollToTop()"
        style="width: 90% !important; left: 0"
      >
        <ion-icon name="arrow-up-outline" style="padding-right: 3px"></ion-icon>
        Scroll to top
      </ion-button>
    </ion-col>
  </ion-content>
</div>
